import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=f650197a&"
import script from "./wrapper.vue?vue&type=script&lang=js&"
export * from "./wrapper.vue?vue&type=script&lang=js&"
import style0 from "./wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports